import React from 'react';
import ReactECharts from 'echarts-for-react';

const RevenueEfficiencyRadar = ({ properties, transactions }) => {
  const propStats = properties.map(p => {
    const tx = transactions.filter(t => t.propertyId === p.id);
    const income = tx.filter(t => t.type === 'Income').reduce((s, t) => s + Number(t.amount), 0);
    const expense = tx.filter(t => t.type === 'Expense').reduce((s, t) => s + Number(t.amount), 0);
    const profit = income - expense;
    return { name: p.name, profit, margin: income > 0 ? (profit / income) * 100 : 0 };
  });

  const option = {
    tooltip: { trigger: 'axis' },
    radar: {
      indicator: propStats.map(p => ({ name: p.name, max: Math.max(...propStats.map(x => x.profit)) * 1.2 })),
      splitArea: { show: false },
      axisLine: { lineStyle: { color: '#E5E7EB' } }
    },
    series: [{
      name: 'Net Profit by Property',
      type: 'radar',
      data: [{ value: propStats.map(p => p.profit), name: 'Actual Profit' }],
      itemStyle: { color: '#4F46E5' },
      areaStyle: { color: 'rgba(79, 70, 229, 0.2)' }
    }]
  };

  return (
    <div className="bg-white p-6 rounded-3xl border border-gray-100 shadow-sm">
      <h3 className="text-xs font-black text-gray-400 uppercase tracking-widest mb-6">Portfolio Efficiency Radar</h3>
      <div className="h-[350px]">
        <ReactECharts option={option} style={{ height: '100%' }} />
      </div>
    </div>
  );
};

export default RevenueEfficiencyRadar;